import request from '@/utils/zsm-requets'
const dist = '/zsm/api/dist/';
const weixin = '/zsm/api/user/weixin/';

/**
 * 通过达人手机号查询达人下关联的抖音列表
 * @param mobile 手机号
 */
export function getLinkListByMobile(params) {
  return request({
    url: weixin + 'getLinkListByMobile',
    method: 'post',
    params
  })
}

/**
 * 通过微信openid获取绑定的抖音列表
 * @param weixinId 达人的微信id
 */
export function distLinkListData(params) {
  return request({
    url: dist + 'listData',
    method: 'post',
    params
  })
}
/**
 * 查询所有达人列表
 * @param pageNo 达人的微信id
 * @param pageSize 页数
 */
export function queryDistMobilePage(params) {
  return request({
    url: dist + 'queryDistMobilePage',
    method: 'post',
    params
  })
}




/**
 * 查询讲师关联的绑定达人
 * @param teacherMobile 老师埃手机号
 * @param distHead 达人头像
 * @param distMobile 达人手机号
 * @param distHead 达人头像
 * @param distNick 达人昵称
 * @param distName 达人姓名
 * @param distRatio 达人分销比例
 * @param distWxld 1.定向达人2普通达人
 * @param goodIdList 关联商品id集合
 * @param  pageNo 当前页数
 * @param  pageSize 每页条数
 */
export function queryTeacherDistPage(params) {
  return request({
    url: dist + 'queryTeacherDistPage',
    method: 'post',
    params
  })
}

/**
 * 查询讲师关联的单个达人信息
 * @param id 绑定的id
 */

export function queryTeacherDist(params) {
  return request({
    url: dist + 'queryTeacherDist',
    method: 'post',
    params
  })
}
/**
 * 绑定现销达人
 * @param teacherMobile 老师埃手机号
 * @param distHead 达人头像
 * @param distMobile 达人手机号
 * @param distHead 达人头像
 * @param distNick 达人昵称
 * @param distName 达人姓名
 * @param distRatio 达人分销比例
 * @param distWxld 1.定向达人2普通达人
 * @param goodIdList 关联商品id集合
 */
export function addToTeacherDistList(params) {
  return request({
    url: dist + 'addToTeacherDistList',
    method: 'post',
    params
  })
}

/**
 * 修改达人状态
 * @param id 编号
 * @param distStatus 1.正常 2.禁用
 */
export function modifyTeacherDistStatus(params) {
  return request({
    url: dist + 'modifyTeacherDistStatus',
    method: 'post',
    params
  })
}


/**
 * 讲师绑定达人
 * @param teacherMobile 老师埃手机号
 * @param distHead 达人头像
 * @param distMobile 达人手机号
 * @param distHead 达人头像
 * @param distNick 达人昵称
 * @param distName 达人姓名
 * @param distRatio 达人分销比例
 * @param distWxld 1.定向达人2普通达人
 * @param goodIdList 关联商品id集合
 */

export function saveTeacherDist(params) {
  return request({
    url: dist + 'saveTeacherDist',
    method: 'post',
    params
  })
  // return request({
  //   headers: {
  //     'Content-Type': 'x-www-form-urlencoded'
  //   },
  //   url: dist + 'saveTeacherDist',
  //   method: 'post',
  //   transformRequest: [function(data) {
  //     data = JSON.stringify(data)
  //     return data
  //   }],
  //   data
  // })
}
